import styled from 'styled-components';
import { flexBetween, flexAlignCenter } from '../../styles/utils.js';

const EmailLoginLayout = styled.div `
  margin: 0 auto;
  width: 400px;
  .login-btn {
    width: 100%;
    height: 44px;
    font-size: var(--font-size-lg);
  }
  .clause-tips {
    ${flexBetween()}
    align-items: center;
    .tips-text {
      padding-left: var(--padding-xs);
    }
  }

  .more-tips {
    ${flexBetween()}
    align-items: center;
    padding-top: var(--padding-md);
    color: var(--text-color-4);
  }
`;
const ModalContentLayout = styled.div `
  padding: var(--padding-md);
  ${flexAlignCenter()}
  flex-direction: column;
  .tips {
    font-size: 20px;
    color: var(--gray-color-3);
    padding-bottom: var(--padding-md);
  }
  .phone {
    color: var(--text-color-1);
    font-size: var(--font-size-lg);
    padding-bottom: var(--padding-xl);
  }
  .modal-btn {
    width: 280px;
    height: 44px;
  }
`;

export { EmailLoginLayout, ModalContentLayout };
